import { GridColumn } from "@progress/kendo-react-grid";
import { SortDescriptor } from "@progress/kendo-data-query";
import { protectedResources } from '../../authConfig';
import { BaseGrid } from '../../components/KendoGrid/BaseGrid';
import { FiveDecimalPlaceNumericFilterCell, NoCommaNumericFilterCell } from "../../components/KendoGrid/NumericFilterCell";
import { GuidFilterCell } from "../../components/KendoGrid/StringFilterCell";
import { AuditActionFilterCell } from "../../components/KendoGrid/AuditActionFilterCell";
import { DateRangeFilter } from "../../components/KendoGrid/DateRangeFilter";

const SubmittedKitAuditList = () => {
    const recentEntriesFirstSort = [{
        field: "AuditDate",
        dir: "desc"
    } as SortDescriptor];

    return (
        <BaseGrid verb={'POST'} pageTitle='Submitted Kit List' endpoint={protectedResources.audit.apiSubmittedKit.endpoint + "KendoGridRead"} intialSort={recentEntriesFirstSort} key={Date.now()}>
            <GridColumn width="240px" field='auditDate' title='Audit Date' filter="date" filterCell={DateRangeFilter} />
            <GridColumn width="140px" field='auditAction' title='Action' filterCell={AuditActionFilterCell} />
            <GridColumn width="200px" field='modifiedByName' title='Modified By Name' />

            <GridColumn width="125px" field='barcode' title='Barcode' />
            <GridColumn width="100px" field='id' title='ID' filterCell={NoCommaNumericFilterCell} filter="numeric" />
            <GridColumn width="100px" field='labId' title='Facility ID' filterCell={NoCommaNumericFilterCell} filter="numeric" />
            <GridColumn width="200px" field='facilityName' title='Facility Name' />
            <GridColumn width="100px" field='operatorId' title='Operator Id' filterCell={NoCommaNumericFilterCell} filter="numeric" />
            <GridColumn width="175px" field='operatorName' title='Operator Name' />
            <GridColumn width="100px" field='pipetId' title='PipetId' filterCell={NoCommaNumericFilterCell} filter="numeric" />
            <GridColumn width="175px" field='serialNumber' title='Serial Number' />
            <GridColumn width="100px" field='pipetDeliveryVolume' title='Volume' filterCell={FiveDecimalPlaceNumericFilterCell} filter="numeric" />
            <GridColumn width="100px" field='review' title='Review' filter="boolean" />
            <GridColumn width="100px" field='locked' title='Locked' filter="boolean" />
            <GridColumn width="100px" field='valuesUsed' title='Values Used' filterCell={NoCommaNumericFilterCell} filter="numeric" />
            <GridColumn width="100px" field='mean' title='Mean' filterCell={FiveDecimalPlaceNumericFilterCell} filter="numeric" />
            <GridColumn width="100px" field='meanPCT' title='Mean PCT' filterCell={FiveDecimalPlaceNumericFilterCell} filter="numeric" />
            <GridColumn width="100px" field='cv' title='CV' filterCell={FiveDecimalPlaceNumericFilterCell} filter="numeric" />
            <GridColumn width="100px" field='sd' title='SD' filterCell={FiveDecimalPlaceNumericFilterCell} filter="numeric" />
            <GridColumn width="150px" field='dateEntered' title='Date Entered' />

            <GridColumn width="340px" field='createdBy' title='Created By' filterCell={GuidFilterCell} />
            <GridColumn width="200px" field='createdByName' title='Created By Name' />
            <GridColumn width="240px" field='createdOn' title='Created On' filter="date" filterCell={DateRangeFilter} />
            <GridColumn width="340px" field='modifiedBy' title='Modified By' filterCell={GuidFilterCell} />
            <GridColumn width="240px" field='modifiedOn' title='Modified On' filter="date" filterCell={DateRangeFilter} />
            <GridColumn width="750px" field='auditUser' title='Audit User' />
        </BaseGrid >
    );
}

export default SubmittedKitAuditList;